
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#2B2B2B","fill-rule":"evenodd","stroke":"#2B2B2B","stroke-width":".5","d":"M11.69 13.637L12.479 3.5H3.521l.791 10.162a.921.921 0 00.912.755h5.553a.927.927 0 00.914-.78zM6.387 2.517v.4h3.228v-.4a.93.93 0 00-.926-.934H7.312a.93.93 0 00-.926.933zm7.324.4c.16 0 .29.13.29.292a.29.29 0 01-.29.291h-.65l-.795 10.208c-.124.76-.75 1.292-1.488 1.292H5.224c-.74 0-1.365-.533-1.486-1.267L2.94 3.5h-.65A.29.29 0 012 3.208a.29.29 0 01.29-.291h3.517v-.4C5.807 1.68 6.482 1 7.312 1h1.376c.83 0 1.505.68 1.505 1.516v.4h3.517zm-3.608 2.005c.006-.163.139-.288.285-.282.152.006.27.143.264.304l-.288 7.814a.283.283 0 01-.274.282h-.01c-.153-.006-.27-.143-.265-.304l.288-7.814zM8.14 4.64c.154 0 .279.131.279.293v7.814a.286.286 0 01-.28.293.286.286 0 01-.279-.293V4.933c0-.162.125-.293.28-.293zm-2.527 0c.157-.007.28.12.285.282l.288 7.814c.006.161-.112.298-.264.304H5.91c-.147 0-.269-.124-.275-.282L5.35 4.944c-.006-.161.113-.298.264-.304z"}})])
          )
        }
      }
    